import React from 'react';
import classNames from 'classnames';

const Loading = ({text, left, inline, curtain}) => (
  <div className={classNames({"loading-block": true, curtain, 'text-inline': inline, 'text-left': left})}>
    <div className="spinner"></div>
    {text && <div className="loading-text">{text}</div>}
  </div>
)

export default Loading;


// WEBPACK FOOTER //
// ./src/components/helpers/Loading.js